import React, { useState, useEffect } from 'react';
import { useFetch } from '../../../helpers/hooks/fetchData';
import styled from 'styled-components';
import { Modal } from '../../shared/modal/Modal';
import { Formik } from 'formik';
import { InputField } from '../../shared/input/InputField';
import * as Yup from 'yup';
import { Button } from '../../shared/button/Button';
import { InputWrapper } from '../../shared/input/InputWrapper';
import { Type } from '../questions/edit-question/Type';

export const EditCategory = ({ category, showModal, setShowModal }) => {
  const [payload, setPayload] = useState({});
  const [initialValues, setInitialValues] = useState({});
  const { data, hasError } = useFetch(payload);
  const errorText = 'Error editing category';
  const [isSurvey, setIsSurvey] = useState(false);
  useEffect(() => {
    setInitialValues({ title: category.title });
    setIsSurvey(category.isSurvey)
  }, [category]);

  const validationSchema = Yup.object().shape({
    title: Yup.string().required('This is a required field.'),
  });

  useEffect(() => {
    if (data) {
      setShowModal(false);
      return window.location.reload();
    }
  }, [data, setShowModal]);

  return (
    <>
      {showModal && (
        <Modal
          show={showModal}
          handleExit={setShowModal}
          title='Edit category'
          width={'40rem'}
        >
          {!hasError && (
            <>
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                values={category}
                enableReinitialize={true}
                onSubmit={async (values) => {
                  values = {
                    ...values,
                  };
                  values.isSurvey = isSurvey;
                  setPayload({
                    endpoint: '/api/omega/categories/' + category._id,
                    method: 'put',
                    data: values,
                    headers: {
                      Accept: 'application/json',
                      'Content-Type': 'application/json',
                    },
                  });
                }}
              >
                {({
                  touched,
                  errors,
                  values,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                }) => (
                  <Form onSubmit={handleSubmit}>
                    <InputField
                      id='title'
                      label='Category name'
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.title || ''}
                      error={errors.title && touched.title}
                      type='text'
                      name='title'
                      placeholder='Name'
                      message={
                        errors.title && touched.title && `${errors.title}`
                      }
                    />
                    <Margin />
                    <InputWrapper marginTop title='Category is survey'>
                      <Type
                        chosenType={isSurvey}
                        setChosenType={setIsSurvey}
                        yesOrNoOption
                      />
                    </InputWrapper>
                    <Button
                      type='submit'
                      disabled={isSubmitting}
                      primary
                      text='Save'
                    />
                  </Form>
                )}
              </Formik>
            </>
          )}
          {hasError && (
            <>
              <ErrorMessage>{errorText}</ErrorMessage>
              <Button secondary onClick={() => setShowModal(false)} text='OK' />
            </>
          )}
        </Modal>
      )}
    </>
  );
};

const ErrorMessage = styled.div`
  color: red;
  font-size: 2rem;
  text-align: center;
  margin-bottom: 30px;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
`;
const Margin = styled.div`
  height: ${(props) => props.theme.spacing.extraLarge};
`;
